module.exports = __webpack_public_path__ + "static/media/min.3423eaac.png";